import API from '@/app-core/api/Api'
import {clone} from '@/app-core/lib/utils/helper'
import NotificationTypeEnum from '@/app-core/api/enums/NotificationTypeEnum'
import {isArray, isObject} from '@/app-core/lib/utils/type'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import DataEventService from '@/app-core/lib/services/event/DataEventService'
import DataEventEnum from '@/app-core/lib/services/enum/DataEventEnum'
import AnalyticsCommon from '@/app-core/mixins/analytics/analyticsCommon'
import OrderTypeEnum from '@/app-core/api/enums/OrderTypeEnum'
import {mergeDeep} from '@/app-core/lib/utils/object'
import CartCommon from '@/app-core/mixins/cart/cartCommon'

export default {
  name: 'cartActions',

  dataStore: {
    AppCart: 'App.Cart'
  },

  mixins: [CartCommon, StoreCommon, AnalyticsCommon],

  data() {
    return {}
  },

  created() {
    const excludedRoutes = ['Home', 'Store', 'CheckoutDetails']
    if (!excludedRoutes.includes(this.$route.name)) this.cartGet()
  },

  beforeDestroy() {
  },

  computed: {
    CartPromiseQueue() {
      return window.CartPromiseQueue
    },

    IsLoading: {
      get() {
        return this.AppCart.Status.IsLoading || false
      },
      set(value) {
        this.AppCart.Status.IsLoading = value
      }
    },
    couponLoading: {
      get() {
        return this.AppCart.Status.CouponLoading || false
      },
      set(value) {
        this.AppCart.Status.CouponLoading = value
      }
    },
    chargeLoading: {
      get() {
        return this.AppCart.Status.ChargeLoading || false
      },
      set(value) {
        this.AppCart.Status.ChargeLoading = value
      }
    },
    scheduledLoading: {
      get() {
        return this.AppCart.Status.ScheduledLoading || false
      },
      set(value) {
        this.AppCart.Status.ScheduledLoading = value
      }
    },
    orderTypeLoading: {
      get() {
        return this.AppCart.Status.OrderTypeLoading || false
      },
      set(value) {
        this.AppCart.Status.OrderTypeLoading = value
      }
    },
    couponValue: {
      get() {
        return this.AppCart.Status.CouponValue || ''
      },
      set(value) {
        this.AppCart.Status.CouponValue = value
      }
    }
  },

  methods: {
    cartGet() {
      this.CartPromiseQueue.push(() => API.Resource.Cart.Get()
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.cartSetData(API.responseData(response))
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.$bus.$emit('cart:get:response', API.responseData(response))
        }))
    },

    cartUpdateScheduled(scheduledOrder) {
      if (!scheduledOrder || this.scheduledLoading) return

      this.scheduledLoading = true
      const payload = {scheduled: scheduledOrder}

      this.CartPromiseQueue.push(() => API.Resource.Cart.Scheduled(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            this.cartSetData(data)
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.scheduledLoading = false
          this.$bus.$emit('cart:scheduled:response', payload, API.responseData(response))
        }))
    },

    cartUpdateOrderType(orderType) {
      if (!orderType || this.orderTypeLoading) return

      this.orderTypeLoading = true
      const payload = {cart: {OrderType: orderType}}

      this.CartPromiseQueue.push(() => API.Resource.Cart.OrderType(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            this.cartSetData(data)
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.orderTypeLoading = false
          this.$bus.$emit('cart:order-type:response', payload, API.responseData(response))
        }))
    },

    cartAddProduct(product) {
      if (!product || product?.Loading) return
      const payload = {
        menu: {
          StoreId     : product.StoreId,
          Id          : product.Id,
          RowId       : product.RowId,
          Quantity    : product.Quantity,
          Comment     : product.Comment,
          Options     : product.Options,
          Price       : product.Price,
          UnitId      : product.UnitId,
          UnitQuantity: product.UnitQuantity
        }
      }

      this.setCartProductLoader(product.RowId, true)
      this.setCatalogProductLoader(product.Id, true)

      this.CartPromiseQueue.push(() => API.Resource.Cart.Add(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            this.cartSetData(data)

            const item = this.menuItemToGAItem(product)
            DataEventService.Emit(DataEventEnum.EVENT, {
              Event  : DataEventEnum.ADD_TO_CART,
              Payload: {
                items            : [item],
                value            : (item.price - item.discount) * item.quantity,
                currency         : item.currency,
                cartTotalQuantity: data?.TotalItems || 0
              }
            })
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.setCartProductLoader(product.RowId, false)
          this.setCatalogProductLoader(product.Id, false)

          this.$bus.$emit('cart:add:response', product, API.responseData(response))
        }))
    },

    cartUpdateProduct(product) {
      if (!product || product?.LoadingUpdate) return
      const payload = {
        menu: {
          StoreId     : product.StoreId,
          RowId       : product.RowId,
          Id          : product.Id,
          Quantity    : product.Quantity,
          Comment     : product.Comment,
          OptionIds   : product.OptionIds,
          Price       : product.Price,
          UnitId      : product.UnitId,
          UnitQuantity: product.UnitQuantity
        }
      }

      this.setCartProductLoader(product.RowId, true, 'LoadingUpdate')

      this.CartPromiseQueue.push(() => API.Resource.Cart.Update(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            this.cartSetData(data)

            const item = this.menuItemToGAItem(product)
            DataEventService.Emit(DataEventEnum.EVENT, {
              Event  : DataEventEnum.UPDATE_CART_ITEM,
              Payload: {
                items            : [item],
                value            : (item.price - item.discount) * item.quantity,
                currency         : item.currency,
                cartTotalQuantity: data?.TotalItems || 0
              }
            })
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.setCartProductLoader(product.RowId, false, 'LoadingUpdate')
          this.$bus.$emit('cart:update:response', product, API.responseData(response))
        }))
    },

    cartRemoveProduct(product) {
      if (!product || product?.LoadingRemove) return
      const payload = {menu: {StoreId: product.StoreId, RowId: product.RowId}}

      this.setCartProductLoader(product.RowId, true, 'LoadingRemove')

      this.CartPromiseQueue.push(() => API.Resource.Cart.Remove(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            this.cartSetData(data)

            const item = this.menuItemToGAItem(product)
            DataEventService.Emit(DataEventEnum.EVENT, {
              Event  : DataEventEnum.REMOVE_FROM_CART,
              Payload: {
                items            : [item],
                value            : (item.price - item.discount) * item.quantity,
                currency         : item.currency,
                cartTotalQuantity: data?.TotalItems || 0
              }
            })
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.setCartProductLoader(product.RowId, false, 'LoadingRemove')
          this.$bus.$emit('cart:remove:response', product, API.responseData(response))
        }))
    },

    cartProductOptions(product) {
      if (!product || product?.LoadingShow) return

      this.setCartProductLoader(product.RowId, true, 'LoadingShow')

      this.CartPromiseQueue.push(() => API.Resource.Cart.Options(product.StoreId, product.Id, product.RowId)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const product = clone(API.responseData(response))
            product.ModifierRuns = 0
            this.selectedProduct = product
            this.productDetailsDialogVisible = true
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.setCartProductLoader(product.RowId, false, 'LoadingShow')
          this.$bus.$emit('cart:options:response', API.responseData(response))
        }))
    },

    cartAddCoupon(coupon) {
      if (!coupon || this.couponLoading) return

      this.couponLoading = true

      this.CartPromiseQueue.push(() => API.Resource.Cart.CouponAdd(coupon)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.cartSetData(API.responseData(response))
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.couponLoading = false
          this.$bus.$emit('cart:coupon-add:response', coupon, API.responseData(response))
        }))
    },

    cartRemoveCoupon(coupon) {
      if (!coupon || this.couponLoading) return

      this.couponLoading = true

      this.CartPromiseQueue.push(() => API.Resource.Cart.CouponRemove(coupon)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.cartSetData(API.responseData(response))
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.couponLoading = false
          this.$bus.$emit('cart:coupon-remove:response', coupon, API.responseData(response))
        }))
    },

    cartAddService(service) {
      if (!service || this.chargeLoading) return

      this.chargeLoading = true

      this.CartPromiseQueue.push(() => API.Resource.Cart.ChargeAdd(service)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.cartSetData(API.responseData(response))
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.chargeLoading = false
          this.$bus.$emit('cart:service-add:response', service, API.responseData(response))
        }))
    },

    cartRemoveService(service) {
      if (!service || this.chargeLoading) return

      this.chargeLoading = true

      this.CartPromiseQueue.push(() => API.Resource.Cart.ChargeRemove(service)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.cartSetData(API.responseData(response))
          }
        })
        .catch(e => {
        })
        .finally((response) => {
          this.chargeLoading = false
          this.$bus.$emit('cart:service-remove:response', service, API.responseData(response))
        }))
    },

    cartSetData(data) {
      if (!data) return

      this.AppCart.Messages = []
      this.$bus.$emit('before:cart:set-data', data)

      const cartData = {
        Items           : data?.Items || [],
        Stores          : data?.Stores || [],
        Totals          : data?.CartTotals || [],
        Messages        : data?.Messages || [],
        CartTotal       : data?.CartTotal || 0,
        OrderTotal      : data?.OrderTotal || 0,
        TotalItems      : data?.TotalItems || 0,
        TotalStores     : data?.TotalStores || 0,
        MinimumOrderDiff: data?.MinimumOrderDiff || 0,
        OrderType       : data?.OrderType || OrderTypeEnum.COLLECTION,
        ScheduledOrder  : data?.ScheduledOrder || {},
        PaymentMethod   : this.selectedPaymentMethod
      }

      const cartDataMerged = mergeDeep(this.AppCart, cartData)
      cartDataMerged.Items = data?.Items || []
      cartDataMerged.Stores = data?.Stores || []
      cartDataMerged.Totals = data?.CartTotals || []
      cartDataMerged.Messages = data?.Messages || []


      this.$set(this, 'AppCart', cartDataMerged)
      this.cartParseMessages(cartDataMerged)
      this.cartUpdateStores(cartDataMerged)

      this.$bus.$emit('after:cart:set-data', cartDataMerged)

      this.validateCartServices()
    },

    validateCartServices() {

      // Reset Order Type (if needed) to Collection when in QRScanApp Mode
      if (this.AppType.isQRScanApp && this.AppConfig.Marketplace.SupportsCollection && this.AppCart.OrderType !== OrderTypeEnum.COLLECTION) {
        this.$bus.$emit('cart:update-order-type', OrderTypeEnum.COLLECTION)
        return false
      }

      // Remove Waiter Service (if needed) when not in QRScanApp Mode
      if (this.cartWaiterService && !this.AppType.isQRScanApp) {
        this.$bus.$emit('cart:remove-service', this.AppWaiterService)
        return false
      }

      return true
    },

    cartUpdateStores(cartData) {
      if (!isArray(cartData?.Stores)) return

      const tmpAppStores = clone(this.AppStores)

      cartData.Stores.forEach(cartStore => {
        const store = tmpAppStores?.find(store => parseInt(store.Id) === parseInt(cartStore.StoreId))
        if (store) {
          store.Status.CollectionTime = cartStore.CollectionTime
          store.Status.DeliveryTime = cartStore.DeliveryTime
          store.Status.HasCollection = cartStore.HasCollection
          store.Status.HasDelivery = cartStore.HasDelivery
          store.Status.IsClosed = cartStore.IsClosed
        }
      })

      this.AppStores = tmpAppStores
    },

    cartParseMessages(data) {
      const CartMessages = data.Messages || []

      if (isObject(CartMessages)) {
        if (CartMessages.Success) {
          this.showCartNotification(CartMessages.Success, '', '', '', NotificationTypeEnum.SUCCESS)
        } else if (CartMessages.Info) {
          this.showCartNotification(CartMessages.Info, '', '', '', NotificationTypeEnum.INFO)
        } else if (CartMessages.Warning) {
          this.showCartNotification(CartMessages.Warning, '', '', '', NotificationTypeEnum.WARNING)
        } else if (CartMessages.Error) {
          this.showCartNotification(CartMessages.Error, '', '', '', NotificationTypeEnum.ERROR)
        }
      }

      if (isArray(CartMessages)) {
        CartMessages.forEach(item => {
          const store = this.getStoreById(item.StoreId)

          if (item.Messages?.Success) {
            this.showCartNotification(item.Messages.Success, store.Name || '', '', store.Logo || '', NotificationTypeEnum.SUCCESS)
          } else if (item.Messages?.Info) {
            this.showCartNotification(item.Messages.Info, store.Name || '', '', store.Logo || '', NotificationTypeEnum.INFO)
          } else if (item.Messages?.Warning) {
            this.showCartNotification(item.Messages.Warning, store.Name || '', '', store.Logo || '', NotificationTypeEnum.WARNING)
          } else if (item.Messages?.Error) {
            this.showCartNotification(item.Messages.Error, store.Name || '', '', store.Logo || '', NotificationTypeEnum.ERROR)
          }

          if (item.Fetch) this.getStoreMenu(item.StoreId)
        })
      }
    },

    getStoreMenu(storeId) {
      if (this.$route.name !== 'Store' || parseInt(this.$route.params.id) !== parseInt(storeId)) return
      this.$bus.$emit('store:get-menu')
    },

    setCartProductLoader(rowId, loading, property = 'Loading') {
      if (!rowId) return

      const cartProduct = this.getProductInCartByRowId(rowId)
      if (cartProduct) this.$set(cartProduct, property, loading)
    },

    getProductInCartByRowId(rowId) {
      return this.AppCart?.Items?.find(item => item.RowId === rowId) || null
    },

    setCatalogProductLoader(productId, loading, property = 'Loading') {
      if (!productId) return

      const catalogProduct = this.getProductInCatalogById(productId)
      if (catalogProduct) this.$set(catalogProduct, property, loading)
    },

    getProductInCatalogById(productId) {
      if (!productId) return null

      const storeMenuItems = this.StoreMenu?.items || []
      for (let i = 0; i < storeMenuItems.length; i++) {
        const products = storeMenuItems[i]?.Items || []
        for (let ii = 0; ii < products.length; ii++) {
          if (products[ii].Id === productId) {
            return products[ii]
          }
        }
      }

      return null
    },

    showCartNotification(message, title, icon, img, type = 'success') {
      if (!message) return

      this.$bus.$emit('app:show-notification', {
        title: title || '',
        body : message || '',
        type : type || 'success',
        icon : icon || '',
        img  : img || ''
      })
    },

    cartQueueStatusUpdate(status) {
      this.IsLoading = !status.idle
    }
  }
}
